import React, {useState, useRef, useEffect} from "react";
import "../index.css";
import {t} from "i18next";
import imageInvest from "../assets/invest.jpg";
import imageReside from "../assets/reside_and_work.jpg";
import imageBusiness from "../assets/start_a_business.jpg";
import imageStudy from "../assets/study.jpg";
import imageRetire from "../assets/retire.jpg";
import imageNationality from "../assets/nationality.jpg";
import imageRegularisation from "../assets/regularisation_arraigo.jpg";
import imageExtraordinaryRegularisation from "../assets/extraordinary_regularisation.jpg";
import { Link } from "react-router-dom";
export default function ServicesSection() {
        const extraordinaryRegularisationVideoUrl =
                process.env.REACT_APP_EXTRAORDINARY_REGULARISATION_VIDEO_URL ||
                `${process.env.PUBLIC_URL || ""}/videos/extraordinary-regularisation.mp4`;

        const services = [
                {
                        image: imageExtraordinaryRegularisation,
                        title: t('service_extraordinary_regularisation_title'),
                        context: t('service_extraordinary_regularisation'),
                        videoUrl: extraordinaryRegularisationVideoUrl
                },
                {
                        image: imageReside,
                        title: t('service_reside_work_title'),
                        context: t('service_reside_work')
                },
                {
                        image: imageBusiness,
                        title: t('service_business_title'),
                        context: t('service_business')
                },
                {
                        image: imageStudy,
                        title: t('service_study_title'),
                        context: t('service_study')
                },
                {
                        image: imageRetire,
                        title: t('service_retire_title'),
                        context: t('service_retire')
                },
                {
                        image: imageNationality,
                        title: t('service_nationality_title'),
                        context: t('service_nationality')
                },
                {
                        image: imageRegularisation,
                        title: t('service_regularisation_title'),
                        context: t('service_regularisation')
                },
                {
                        image: imageInvest,
                        title: t('service_invest_title'),
                        context: t('service_invest'),
                        isUnavailable: true
                }
        ]

        const Modal = ({ isOpen, onClose, content, videoUrl }) => {
                const modalContentRef = useRef(null);

                const handleClickOutside = (event) => {
                        if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
                                onClose();
                        }
                };

                useEffect(() => {
                        if (isOpen) {
                                document.addEventListener('mousedown', handleClickOutside);
                                document.body.style.overflow = 'hidden';
                        }
                        return () => {
                                document.removeEventListener('mousedown', handleClickOutside);
                                document.body.style.overflow = '';
                        };
                }, [isOpen, onClose]);

                if (!isOpen) return null;

                return (
                    <div className="modal-background fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4 z-50">
                            <div className="modal-content w-full max-h-[90vh] flex flex-col bg-primary-light dark:bg-primary-dark rounded-lg shadow-xl overflow-hidden relative my-auto" ref={modalContentRef}>
                                    <button onClick={onClose} className="absolute top-0 right-0 z-10 text-primary-light dark:text-primary-dark p-2 m-2 bg-primary-light dark:bg-primary-dark">
                                            &times;
                                    </button>
                                    <div className="text-secondary-light dark:text-secondary-dark max-w-2xl mx-auto text-new-line space-y-4 p-4 pt-12 pb-8 overflow-y-auto overscroll-contain min-h-0 flex-1">
                                            {videoUrl && (
                                                    <div className="w-full max-w-xl mx-auto max-h-[40vh] sm:max-h-[50vh]">
                                                            <video
                                                                    className="w-full h-full max-h-[40vh] sm:max-h-[50vh] rounded-lg shadow-md object-contain"
                                                                    controls
                                                                    preload="metadata"
                                                                    playsInline
                                                            >
                                                                    <source src={videoUrl} type="video/mp4" />
                                                                    Your browser does not support the video tag.
                                                            </video>
                                                    </div>
                                            )}
                                            <div>{content}</div>
                                    </div>
                            </div>
                    </div>
                );
        };


        const [modalOpen, setModalOpen] = useState(false);
        const [modalContent, setModalContent] = useState(null);
        const [modalVideoUrl, setModalVideoUrl] = useState(null);

        const openModal = (item) => {
                setModalContent(item.context);
                setModalVideoUrl(item.videoUrl || null);
                setModalOpen(true);
        };


        const closeModal = () => {
                setModalOpen(false);
        };

        return (
        <>
                <section className="relative md:py-24 py-16 bg-primary-light dark:bg-primary-dark active" id="services">
                        <div className="container">
                                <div className="grid grid-cols-1 pb-8 text-center">
                                        <h3 className="mb-4 md:text-2xl text-xl font-medium text-primary-light dark:text-primary-dark">{t('services')}</h3>
                                </div>

                                <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6 mt-8">
                                        {services.map((item, index) => (
                                            <div className="relative rounded-md shadow-sm overflow-hidden group hover:cursor-pointer" onClick={() => openModal(item)} key={index}>
                                                    {item.isUnavailable && (
                                                        <div className="absolute top-0 left-0 right-0 bg-red-600 text-white text-center py-2 px-4 z-20 font-semibold text-sm md:text-base">
                                                                {t('service_unavailable')}
                                                        </div>
                                                    )}
                                                    <img
                                                        src={item.image}
                                                        className="group-hover:origin-center group-hover:scale-110 group-hover:rotate-3 hover:cursor-pointer transition duration-500 h-max"
                                                        alt={item.title || t('services')}
                                                        loading="lazy"
                                                    />
                                                    <div className="absolute inset-0 group-hover:bg-black opacity-50 transition duration-500 z-0"></div>
                                                    <div className="content">
                                                            <div className="absolute z-10 bottom-4 start-4 transition-all duration-500">
                                                                    <Link to="#" className="h6 text-lg text-primary-dark hover:text-blue-700 transition duration-500 font-semibold bg-black bg-opacity-70 p-1 rounded" onClick={() => openModal(item)}>{item.title}</Link>
                                                            </div>
                                                    </div>
                                            </div>
                                        ))}
                                </div>
                        </div>
                </section>
                <Modal isOpen={modalOpen} onClose={closeModal} content={modalContent} videoUrl={modalVideoUrl} />
 
        </>
    );
}
